<div class="flex flex-col h-full w-full overflow-hidden">
    @if(!(selectedAgent && isWeeklyAgentsNotRun) && (chartLabels && chartLabels.length > 0) && (isAllAgentsEmailOnly ? (barChartData && barChartData.length > 0) : (selectedAgent ? (chartData | hasChartData: chartLabels) : true))) {
        @if(!selectedAgent && !isAllAgentsEmailOnly && !isAllAgentsExportOnly) {
            <p class="card-sub-header-text pb-2">All Growth Signal Agent activity over the past 4 weeks</p>
        } @else {
            @if(isAllAgentsEmailOnly) {
                <p class="card-sub-header-text pb-2">Companies surging over the past 4 weeks</p>
            } @else {
                <p class="card-sub-header-text pb-2">Companies and contacts exported over the past 4 weeks</p>
            }
        }
        @if(isShowChart) {
            @if(isAllAgentsEmailOnly) {
                <app-bar-chart class="flex flex-col w-full h-full" [chartData]="barChartData" [chartLabels]="chartLabels" [showDataLabel]="true" [showHorizontalGridLines]="true" [showTooltips]="false" [useAbbreviationYAxis]="true"></app-bar-chart>
            } @else {
                <app-line-chart class="flex flex-col w-full h-full" [chartData]="chartData" [chartLabels]="chartLabels" 
                [legendKeyToHide]="growthSignalsDataLabelsEnum.ALL_COMPANIES"
                ></app-line-chart>
            }
        } @else {
            <div class="table-container">
                <app-data-table [data]="tableData" [columns]="tableColumns" sortActive="displayDate" sortDirection="asc" smallRowHeight="true" [layoutFixed]="false">
                </app-data-table>
            </div>
        }
    } @else {
        <div class="h-full w-full p-4 content-center text-center font-bold">
        <div class="card-info pb-4">This agent hasn’t run yet, so we don’t have any data to show you. Use the button below to manually run your agent.</div>
        <button matButton="filled" type="button" (click)="runAgent.emit()">Run Agent</button>
        </div>
    }
</div>